import _toLower from 'lodash/toLower';
import _startCase from 'lodash/startCase';
import { DocumentationValidationStatusEnum } from 'graphql-common';
import { ChipTypes } from '@lib/components/Chip/Chip';
import getValidationStatusOptions from '@lib/utils/documentation/getValidationStatusOptions';

export interface ValidationStatusChipProps {
  labelKey: string;
  color: ChipTypes;
}

export default function getValidationStatusChipProps(
  statusValue: string | null | undefined,
): ValidationStatusChipProps | null {
  if (!statusValue) return null;
  const normalized =
    statusValue.toUpperCase() as DocumentationValidationStatusEnum;
  const option = getValidationStatusOptions().find(
    ({ value }) => value === normalized,
  );
  if (!option) {
    return {
      labelKey: _startCase(_toLower(statusValue)),
      color: ChipTypes.chipDisabled,
    };
  }
  return option;
}
